import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/115'

const AverageCheckByLocationTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="revenue.tabs.average_check_by_location"
  />
)

export default AverageCheckByLocationTab
